import { Snackbar, Alert } from '@mui/material';
import { appConfigs } from '../constants/ApplicationConstants';


export default function PageMessage({show, message, type, clearPageMessage}){
    
    return (
        <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={show} autoHideDuration={appConfigs.errorMessageHideDuration} onClose={clearPageMessage}>
          <Alert
            severity={type}
            variant="filled"
          >
              {message}
          </Alert>
      </Snackbar>
    );
}